import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {VideoData} from "../constants/const";
import VideoItem from "../components/VideoItem";
import leftArrow from "../assets/icons/left-arrow.svg";
import {useNavigate} from "react-router";

function HowToPlay () {
    const [size, setSize] = useState<any>(null);
    const {t} = useTranslation();
    const navigate = useNavigate();


    const handleVideo = (el: any) => {
        setSize(el)
    };

    const [value, setValue] = useState(localStorage.getItem('lang'));

    useEffect(() => {
        const interval = setInterval(() => {
            const newValue = localStorage.getItem('lang');
            if (newValue !== value) {
                setValue(newValue);
            }
        }, 500); // проверка каждые полсекунды

        return () => clearInterval(interval);
    }, [value]);

    return (
        <div className="how-to-play">
            <div className="video-block-header">
                <div className="jackpot_title">
                    <img src={leftArrow}
                         alt="icon"
                         width={32}
                         height={32}
                         onClick={() => {
                             navigate('/more')
                         }}
                    />
                    <span> {t('Как играть')}?</span>
                </div>
            </div>
            {["RU", "EN", "ES", "PT", "TR"].includes(value || "") && (
                <div key={value} className="video-info-block">
                    <video
                        key={value}
                        controls
                        style={{ height: "212px", borderRadius: "16px" }}
                        playsInline
                    >
                        <source
                            src={
                                value === "RU"
                                    ? "https://cryptolottery777.com/public/video/1"
                                    :  value === "EN"?`https://cryptolottery777.com/public/video/1/en`
                                        :  value === "ES"? `https://cryptolottery777.com/public/video/1/es`
                                            : value === "PT"? `https://cryptolottery777.com/public/video/1/pt`
                                                : value === "TR"? `https://cryptolottery777.com/public/video/1/tr`
                                                    :""
                            }
                            type="video/mp4"
                        />
                        {t("Ваш браузер не поддерживает HTML-видео.")}
                    </video>
                </div>
            )}
            {/*<div className="video-block">*/}
            {/*    {VideoData.map((video, index) => {*/}
            {/*        return (*/}
            {/*            <VideoItem*/}
            {/*                size={size}*/}
            {/*                close={() => setSize(null)}*/}
            {/*                func={() => handleVideo(index)}*/}
            {/*                index={index}*/}
            {/*                key={index}*/}
            {/*                src={video.src}*/}
            {/*                image={video.image}*/}
            {/*                text={video.text}*/}
            {/*            />*/}
            {/*        )*/}
            {/*    })}*/}
            {/*</div>*/}

        </div>
    )
}

export default HowToPlay
